module.exports = __webpack_public_path__ + "assets/screen-6705fe.svg";